import React from "react";
import { Glyphicon } from "react-bootstrap";
import { Link } from "react-router-dom";
import Toast from "../../../../../components/common/toast/Toast";
import _ from "lodash";

import { formatDateSmall } from "../../../../../utils/dates";
import Table from "../../../../../components/common/table/Table";
import MatchRowOverlay from "./matchRowOverlay/MatchRowOverlay";
import arrowRightIcon from "../../../../../assets/images/arrow-right.svg";
import noMatchesIcon from "../../../../../assets/images/empty-project.svg";
import Button from "../../../../../components/common/button/Button";

import { Mixpanel } from "../../../../../actions/mixpanel.actions";
import { PROJECT_MATCHES_TABLE } from "../../../../../actions/project.actions";

import styles from "./Matches.scss";
class Matches extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showRejectedProjects: false
    };

    this.toogleRejectedProjects = this.toogleRejectedProjects.bind(this);
  }

  componentDidMount() {
    if (localStorage.getItem("Review:Id")) {
      this.toast.showToast(this.onToastClose);
      localStorage.removeItem("Review:Id");
    }
  }

  render() {
    const matches = this.getCurrentMatches();
    const mappedMatches = matches.map(match => {
      const { project } = match;
      return {
        rowKey: match.id,
        overlayComponent: (
          <MatchRowOverlay
            id={match.id}
            onCancel={this.props.removeTableOverlay}
            onSuccess={this.props.rejectMatch}
            positionText={project.title}
            companyText={_.get(project, "employer.profile.company.name")}
          />
        ),
        disabled: match.declined,
        paused: project.status_id === 10,
        data: [
          {
            displayText: this.getProjectDisplayText(project),
            orderByText: project.title
          },
          {
            displayText: formatDateSmall(match.updated_at),
            orderByText: match.updated_at
          },
          {
            displayText: this.getActions(match)
          }
        ]
      };
    });

    return (
      <React.Fragment>
        <Toast
          onRef={ref => (this.toast = ref)}
          title="Thank you."
          content="Your feedback has been submitted."
        />
        {mappedMatches.length > 0
          ? this.renderMatches(mappedMatches)
          : this.renderNoMatches()}
      </React.Fragment>
    );
  }

  getCurrentMatches() {
    let matches;
    if (this.state.showRejectedProjects) {
      matches = _.filter(this.props.matches, { pitched: false });
    } else {
      matches = _.filter(this.props.matches, {
        declined: false,
        pitched: false
      });
    }

    return matches;
  }

  getFilterButtons() {
    const toogleRejectedComponent = this.state.showRejectedProjects ? (
      <span>
        {" "}
        <Glyphicon glyph="eye-close" /> &nbsp; Hide Rejected{" "}
      </span>
    ) : (
      <span>
        {" "}
        <Glyphicon glyph="eye-open" /> &nbsp; Show Rejected{" "}
      </span>
    );

    return (
      <div className={styles.filterButtons}>
        <span
          className={styles.filterButtonsItem}
          onClick={this.toogleRejectedProjects}
        >
          {toogleRejectedComponent}
        </span>
      </div>
    );
  }

  getProjectDisplayText(project) {
    const company = _.get(project, "employer.profile.company") || {};

    return (
      <div className={styles.rowHeader}>
        <div>
          <Link
            to={`/member/company/${company.id}`}
            onClick={() =>
              Mixpanel.track("Member - Matches - Project Company Name")
            }
          >
            {company.name}
          </Link>
        </div>

        <div className={styles.rowHeaderSubtitle}>
          <Link
            to={`/member/project/${project.id}/detail`}
            onClick={() =>
              Mixpanel.track("Member - Matches - Project Job Title")
            }
          >
            {project.title}
          </Link>
        </div>
      </div>
    );
  }

  getActions(match) {
    const { id, declined, declined_at, project } = match;

    const paused = project.status_id === 10;

    const enabledRowComponent = () => (
      <div className={styles.actionsContainer}>
        <Link
          to={`/member/project/${project.id}/detail`}
          className={styles.blueButton}
          onClick={() =>
            Mixpanel.track("Member - Matches - Project See Details")
          }
        >
          {" "}
          SEE DETAILS{" "}
        </Link>

        <Glyphicon
          glyph="trash"
          className={styles.noThanksButton}
          onClick={() => {
            this.props.setTableOverlay(id);
            Mixpanel.track("Member - Matches - Project Delete Modal");
          }}
        />

        <Link
          to={`/member/project/${project.id}/detail`}
          onClick={() => Mixpanel.track("Member - Matches - Project Arrow")}
        >
          <img src={arrowRightIcon} className={styles.arrowButton} />
        </Link>
      </div>
    );

    const pausedRowComponent = () => (
      <div
        className={styles.actionsContainer}
        style={{ justifyContent: "center" }}
      >
        <span>Project Paused</span>
      </div>
    );

    const disabledRowComponent = () => (
      <div className={styles.actionsContainer}>
        <span>Declined on {formatDateSmall(declined_at)}</span>
        <span
          className={styles.undoButton}
          onClick={() => {
            this.props.undoRejection(id);
          }}
        >
          Undo
        </span>
      </div>
    );

    let component = enabledRowComponent();

    if (declined) {
      component = disabledRowComponent();
    } else if (paused) {
      component = pausedRowComponent();
    }

    return component;
  }

  toogleRejectedProjects() {
    this.setState(prevState => {
      return {
        showRejectedProjects: !prevState.showRejectedProjects
      };
    });
  }

  renderNoMatches() {
    return (
      <div className={styles.noMatches}>
        <div className={styles.noMatchesMsg}>
          <img
            src={noMatchesIcon}
            alt="noCandidatesIcon"
            className={styles.noMatchesIcon}
          />
          <div className={styles.noMatchesMsgText}>
            <p>You are not matched to any projects.</p>
            <p>
              Make sure your profile is up to date with accurate skills and
              location.
            </p>
          </div>
          <Link to={`/member/profile`}>
            <Button isPrimary isSmall label="EDIT PROFILE" />
          </Link>
        </div>
      </div>
    );
  }

  renderMatches(mappedMatches) {
    const tableData = {
      headers: [
        {
          displayText: "PROJECT",
          id: "table-member-matches-sort-project",
          track: "Table - Member Matches - Sort By Project"
        },
        {
          displayText: "MATCHED",
          id: "table-member-matches-sort-matched",
          track: "Table - Member Matches - Sort By Matched"
        },
        {
          displayText: this.getFilterButtons(),
          id: "table-member-matches-sort-rejected",
          track: "Table - Member Matches - Sort By Rejected",
          align: "right",
          sortDisabled: true
        }
      ],
      rows: mappedMatches
    };

    const defaultSort = {
      headerIndex: 1,
      order: "desc"
    };

    return (
      <div className={styles.matches}>
        <h2 className={styles.pageTitle}>Matches</h2>
        <p className={styles.pageSubTitle}>
          Opportunity knocks! Here are the projects that match your skills.
        </p>
        <p className={styles.pageSubTitle}>
          Click the company name to learn more about them, and the project title
          to read more about the project itself.
        </p>
        <p className={styles.pageSubTitle}>
          Interested? Click “Pitch it” to submit your pitch.
        </p>
        <p className={styles.pageSubTitle}>
          Not a fit? Click the trash can to remove it from your matches list.
        </p>

        <div className={styles.divider}>
          <div className={styles.top} />
          <div className={styles.bottom} />
        </div>

        <Table
          name={PROJECT_MATCHES_TABLE}
          colsConfig={["50%", "20%", "30%"]}
          defaultSort={defaultSort}
          tableData={tableData}
        />
      </div>
    );
  }

  renderOverlay;
}

export default Matches;



// WEBPACK FOOTER //
// ./src/routes/candidate/projects/matches/components/Matches.js